import { Redirect } from 'react-router-dom';

import useNav from 'app/hooks/useNav';

const HomeRedirect = () => {
  // redirect to first nav link.
  // if it ever becomes a menu then this will need to change
  const {
    getNavLinks
  } = useNav();

  const navLinks = getNavLinks();
  const redirectPath = navLinks[0].path;

  return <Redirect to={redirectPath} />;
}

export default HomeRedirect;
